import { Injectable, inject } from '@angular/core';
import { ApiService } from 'src/app/core/http/api.service';
import { HttpResponse } from '@angular/common/http';
import { GcmLoadingService, GcmNotificationService } from '@gcm/gcm-ui-angular';

@Injectable({
  providedIn: 'root'
})
export class SnapshotService {
  private apiService = inject(ApiService);
  private notificationService = inject(GcmNotificationService);
  private loadingService = inject(GcmLoadingService);

  getSnapshot(reportingDate: string, fileName: string, investorId: number, seriesId: number, dealId?: number, assetMasterId?: number, caseStudy?: boolean) {
    const loadingTask = 'downloadingSnapshot'
    this.loadingService.addAsyncTask(loadingTask);
    const url = this.apiService.getSnapshotRoute(reportingDate, investorId, seriesId, dealId, assetMasterId, caseStudy);
    this.apiService.downloadSnapshot(url).subscribe({
      next: (blob: HttpResponse<Blob>) => {
        const a = document.createElement('a');
        if (!blob.body) return;
        const file = URL.createObjectURL(blob.body);
        a.href = file;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.loadingService.resolveAsyncTask(loadingTask);
      },
      error: (err) => {
        this.loadingService.resolveAsyncTask(loadingTask);
        this.notificationService.notifyError(err);
      }
    })
  }
}
